<div class="page-shell">
<mat-toolbar class="header">
  <span>{{ "printCardOrders.title" | translate }}: {{ total }}</span>
  <div class="actions">
    <button mat-stroked-button (click)="loadOrders()" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
      {{ "printCardOrders.refresh" | translate }}
    </button>
    <button
      mat-stroked-button
      (click)="openMergeDialog()"
      [disabled]="loading || merging"
    >
      <mat-icon>call_merge</mat-icon>
      {{ "printCardOrders.merge.action" | translate }}
    </button>
    <button
      mat-stroked-button
      (click)="downloadPricing()"
      [disabled]="downloadingPricing"
    >
      <mat-spinner
        *ngIf="downloadingPricing"
        diameter="20"
        class="dc-btn-spinner"
      ></mat-spinner>
      <mat-icon *ngIf="!downloadingPricing">download</mat-icon>
      {{
        downloadingPricing
          ? ("loading" | translate)
          : ("printCardOrders.downloadPricing" | translate)
      }}
    </button>
  </div>
</mat-toolbar>

<div class="print-card-orders-wrapper">
  <form [formGroup]="filters" class="filters-row">
    <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        formControlName="search"
        [placeholder]="'printCardOrders.searchPlaceholder' | translate"
        [attr.aria-label]="'printCardOrders.search' | translate"
      />
    </mat-form-field>
  </form>

  <div
    class="table-container"
    [class.table-container--empty]="isEmpty || showNoSearchResults"
    [class.table-container--loading]="loading"
  >
    <mat-table
      [dataSource]="dataSource"
      class="orders-table mat-elevation-z0"
    >
      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef>{{ "printCardOrders.createdAt" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.createdAt | localizedDate : "short" }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="domain">
        <mat-header-cell *matHeaderCellDef>{{ "domain" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.domain }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="employee">
        <mat-header-cell *matHeaderCellDef>{{ "printCardOrders.employee" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="table-cell-stack">
          <div class="employee-cell">
            <span class="employee-name" *ngIf="element.recipients?.length > 1">
              {{ "printCardOrders.groupRecipientsCount" | translate : { count: element.recipients.length } }}
            </span>
            <span class="employee-name" *ngIf="element.recipients?.length <= 1">
              {{ element.employeeName || element.employeeEmail }}
            </span>
            <span class="employee-email">
              {{ "cardOrders.placedBy" | translate }}: {{ element.placedByName || element.placedByEmail }}
            </span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="items">
        <mat-header-cell *matHeaderCellDef>{{ "printCardOrders.items" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ orderItemsSummary(element) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>{{ "printCardOrders.status" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="stage-badge" [attr.data-stage]="element.status">
            {{ getFulfillmentStageLabelKey(element.status) | translate }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="table-actions">
            @if (orderDetailLink(element); as link) {
              <a class="action-btn" [routerLink]="link" data-table-no-row-nav>
                <mat-icon>visibility</mat-icon>
                {{ "printCardOrders.details" | translate }}
              </a>
            }
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="orders-table__row"
        [appTableRowLink]="orderDetailLink(row)"
      ></mat-row>
    </mat-table>

    <div class="loading-wrapper" *ngIf="loading">
      <app-loading></app-loading>
    </div>

    <div class="empty-state" *ngIf="!loading && isEmpty">
      <mat-icon class="empty-state__icon">shopping_bag</mat-icon>
      <p>{{ "printCardOrders.empty" | translate }}</p>
    </div>

    <div class="empty-state" *ngIf="showNoSearchResults">
      <mat-icon class="empty-state__icon">search_off</mat-icon>
      <p>{{ "printCardOrders.searchNoResults" | translate }}</p>
    </div>
  </div>

  <mat-paginator
    *ngIf="total > 0"
    [length]="total"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="changePage($event)"
  ></mat-paginator>
</div>
</div>
